import { render, staticRenderFns } from "./OrganizationUsersTab.vue?vue&type=template&id=27590aab&"
import script from "./OrganizationUsersTab.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports